import React, {memo, useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from '@mui/material/StepButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Paper} from '@mui/material'
import {Head} from "../../../components";
import ModelUploader from "../../../components/ModelUploader";
import BrandBasicInfo from "../../../components/Brand/basic";
import BrandEditSeo from "../../../components/Brand/EditSeo";
import {useParams} from "react-router-dom";

const actions = [
    { name: 'اطلاعات اولیه', 'step' : 0 },
    { name: 'اطلاعات سئو و محتوا', 'step' : 1 },
    { name: 'گالری تصاویر', 'step' : 2 },
];

const BrandEdit = memo((props) => {


    const { id } = useParams();

    const [step, setStep] = useState(0);
    const [brandID, setBrandId] = useState(id ? id : null);


    const switchStep = () => {
        switch (step) {
            case 0:
                return (<BrandBasicInfo brandID={brandID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 1:
                return (<BrandEditSeo brandID={brandID} onComplete={() => {
                    setStep(step + 1);
                }}/>)
                break;
            case 2:
                return (<ModelUploader model={'brand'} entityID={brandID}/>);
                break;

        }
    };


    const handleChangeTab = (event, newValue) => {
        setStep(newValue);
    };

    return(
        <Container>
            <Head data={{ 'link': '/product/brand', 'title': 'ویرایش برند', 'description': 'ویرایش اطلاعات برند'}} />
            <Box mt={5}>
                {!id ? <Stepper elevation={1} alternativeLabel activeStep={step}>
                    {actions.map((item, index) => {
                        return(<Step key={item.step}>
                            <StepButton onClick={() => {
                                if (brandID) {
                                    setStep(item.step)
                                }
                            }}>
                                <StepLabel>
                                    <span>{item.name}</span><br/>
                                </StepLabel>
                            </StepButton>
                        </Step>);
                    })}
                </Stepper> : <Paper>
                    <Tabs
                        value={step}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        {actions.map((item) => {
                            return(
                                <Tab label={item.name} />
                            );
                        })}

                    </Tabs>
                </Paper>}
                {switchStep()}
            </Box>
        </Container>
    );
})



export default BrandEdit;